// extracted by mini-css-extract-plugin
module.exports = {"base":"btn-status_base__2u4S-","decline":"btn-status_decline__1o5SP","approve":"btn-status_approve__33TkN","confirm_action":"btn-status_confirm_action__lDoMR"};